import { render, staticRenderFns } from "./VideoChannelList.vue?vue&type=template&id=09f0cfc2&scoped=true&"
import script from "./VideoChannelList.vue?vue&type=script&lang=ts&"
export * from "./VideoChannelList.vue?vue&type=script&lang=ts&"
import style0 from "./VideoChannelList.vue?vue&type=style&index=0&id=09f0cfc2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09f0cfc2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VImg } from 'vuetify/lib/components/VImg';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VBtn,VImg,VSimpleTable})
